import { ContainerComponent, wrap } from 'AppReact';
import { BorderlessKeyInput, SecondaryTextSm } from 'atoms';
import Controller from './controller';
import {
  FilterHeaderWrapper, FlexBoxWrapper, FlexCenterWrapper, Mr1, Mr2,
} from 'wrappers';
import { PlainHeaderDropdown } from 'containers';
import internalState from './internalState';

export const definition = {
  name: 'TimeInput',
  controller: Controller,
  initialProps: ({ timeValue }) => ({
    timeValue,
    hour: timeValue?.split(':')?.[0] ?? '',
    minute: timeValue?.split(':')?.[1]?.split(' ')?.[0] ?? '',
    ampm: timeValue?.split(' ')?.[1] ?? 'AM'
  }),
  props: internalState,
  elements: [
    {
      wrapper: FilterHeaderWrapper,
      name: "__transparent__",
      displayState: ({ }) => ({ enableFullWidth: true, hasBackground: true }),
      elements: [
        {
          wrapper: FlexCenterWrapper,
          name: 'Wrapper',
          elements: [
            {
              wrapper: FlexBoxWrapper,
              name: 'HourWrapper',
              ref: ({ hourInputRef }) => hourInputRef,
              elements: [
                {
                  component: wrap(BorderlessKeyInput, Mr1),
                  name: 'Input',
                  bindings: ({ hour, minute, ampm, minuteInputRef }) => ({ value: hour, placeholder: 'hh', minute, ampm, minuteInputRef }),
                  displayState: ({ }) => ({ minWidth: '26px', width: '26px', padding: '0px' }),
                },
              ]
            },
            {
              component: wrap(SecondaryTextSm, Mr1),
              name: 'Column',
              displayValue: ({ }) => ':'
            },
            {
              wrapper: FlexBoxWrapper,
              name: 'MinuteWrapper',
              ref: ({ minuteInputRef }) => minuteInputRef,
              elements: [
                {
                  component: wrap(BorderlessKeyInput, Mr2),
                  name: 'Input',
                  bindings: ({ hour, minute, ampm, hourInputRef }) => ({ value: minute, placeholder: 'mm', hour, ampm, hourInputRef }),
                  displayState: ({ }) => ({ minWidth: '26px', width: '26px', padding: '0px' }),
                },
              ]
            },
            {
              component: PlainHeaderDropdown,
              name: 'AMPMDropdown',
              bindings: ({ ampm, hour, minute }) => ({
                options: [
                  { id: 'AM', displayName: `AM` },
                  { id: 'PM', displayName: `PM` },
                ],
                hasSearch: false,
                hour, minute,
                pageSize: 20,
                selectedOptionId: ampm,
                hideCaret: true
              })
            }
          ]
        }
      ]
    },
  ]
}

export default ContainerComponent(definition);